/**
 * ч.1311 — групи прав для редактора ролей і попапу «права ролі»: за ОБЛАСТЮ обліку з довідника
 * прав (сервер, `permission_areas.py`: продажі, закупівлі, гроші, податки, кадри…), не за
 * технічним модулем. Без області у довіднику (старі відповіді, тести) — запасний варіант:
 * модуль довідника з українською назвою.
 */
import type { PermissionCatalogItem } from '@/api/admin';
import { moduleName } from '@/utils/moduleNames';
import { permKindNote } from './permissionKind';

export interface PermRow { code: string; name: string; note: string; rank: number }
export interface PermGroup { key: string; label: string; order: number; perms: PermRow[] }

const SUFFIX_RANK: [string[], number][] = [
  [['.view'], 0],
  [['.create', '.upload', '.open', '.accrue'], 1],
  [['.post', '.register_erpn', '.fiscalize', '.confirm', '.close', '.run'], 2],
  [['.manage', '.edit', '.use'], 3],
  [['.delete', '.void', '.writeoff'], 4],
];
export function rankOf(code: string): number {
  for (const [suffixes, rank] of SUFFIX_RANK) if (suffixes.some((s) => code.endsWith(s))) return rank;
  return 5;
}

export function groupPermissions(codes: string[], catalog: PermissionCatalogItem[] | undefined): PermGroup[] {
  const meta = new Map((catalog ?? []).map((c) => [c.code, c]));
  const groups = new Map<string, PermGroup>();
  for (const code of codes) {
    const m = meta.get(code);
    const key = m?.area ?? m?.module ?? code.split('.')[0] ?? 'other';
    const label = m?.area_label ?? moduleName(m?.module ?? code.split('.')[0] ?? 'other');
    const order = m?.area_order ?? 1000;
    const g = groups.get(key) ?? { key, label, order, perms: [] };
    g.perms.push({ code, name: m?.name ?? code, note: permKindNote(m), rank: m?.rank ?? rankOf(code) });
    groups.set(key, g);
  }
  return [...groups.values()]
    .map((g) => ({ ...g, perms: g.perms.sort((a, b) => a.rank - b.rank || a.name.localeCompare(b.name, 'uk')) }))
    .sort((a, b) => a.order - b.order || a.label.localeCompare(b.label, 'uk'));
}
